
export default {
  name: 'BlogWidget',
  props: ['post','hideCategory','hideDate', 'titleClass', 'target'],
  data() {
    return {
      link: '',
      formattedDate: ''
    }
  },
  created() {
    const lang = this.$i18n.locales.filter(i => i.iso.includes(this.$i18n.locale))[0].iso
    this.link = this.$prismic.linkResolver(this.post)
    this.formattedDate = Intl.DateTimeFormat(lang, {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    }).format(new Date(this.post.data.date))
  }
}
